// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","pipeSpacer":"Footer_pipeSpacer__QxX0B","itemSpacer":"Footer_itemSpacer__il0KM","horizontal_list":"Footer_horizontal_list__MLlWC"};